import { useTranslation } from "react-i18next";

/**
 * ThanksScreen — 送信完了画面。
 *
 * 紙票の末尾にあった「事後措置の連絡先」案内をテキストで伝えつつ、
 * 回答そのものは送信済みであることを明示する。
 */
export function ThanksScreen() {
  const { t } = useTranslation("respond");
  return (
    <section className="space-y-6">
      <header className="space-y-1">
        <h2 className="text-base font-semibold">{t("thanks.title")}</h2>
        <p className="text-sm text-muted-foreground">{t("thanks.description")}</p>
      </header>
      <div className="rounded-md border border-border bg-muted/40 p-4 text-sm text-muted-foreground">
        {t("thanks.notice")}
      </div>
    </section>
  );
}
